module.exports = __webpack_public_path__ + "static/img/story_banner.21fac76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/story_banner.png
// module id = kGqo
// module chunks = 1